
import { computed, defineComponent, PropType } from 'vue'

/**
 * Общая оболочка виджета: заголовок, статус «всё в порядке / требует внимания»,
 * время обновления, кнопка обновления, состояние ошибки с повтором.
 * При ошибке обновления прежние данные остаются на экране (затемнены).
 */
export default defineComponent({
  name: 'DashboardWidget',
  props: {
    title: { type: String, required: true },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    error: { type: String as PropType<string | null>, default: null },
    attention: { type: Number, default: 0 },
    updatedAt: { type: Object as PropType<Date | null>, default: null },
  },
  emits: ['refresh'],
  setup(props) {
    const time = computed(() =>
      props.updatedAt
        ? props.updatedAt.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
        : ''
    )
    return { time }
  },
})
